import styled from "@emotion/styled";

export const BannerContainer = styled.div`
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  justify-content: center;
  object-fit: cover;
  align-items: center;
  @media (max-width: 768px) {
    height: 100%;
  }
`;

export const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  background-color: #006437;
`;
